import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=019149d9&scoped=true&"
import script from "./SectionTitle.ts?vue&type=script&lang=ts&"
export * from "./SectionTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SectionTitle.scss?vue&type=style&index=0&id=019149d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019149d9",
  null
  
)

export default component.exports